import React from "react";
import cx from "classnames";
import { Container } from "src/components/container";
import { BlockContent } from "src/components/block-content";

import { useInView } from "react-intersection-observer";

import * as styles from "./quote.module.css";

export interface SustainabilityQuoteProps {
	quote: any[];
	show: boolean;
	credit: string;
}

export const SustainabilityQuote = ({
	data,
}: {
	data: SustainabilityQuoteProps;
}) => {
	const { quote, show, credit } = data;

	const { ref, inView } = useInView({
		threshold: 0.5,
	});

	return (
		<div className={styles.quote} ref={ref}>
			<Container>
				<BlockContent
					className={cx("ac title highlight-em", inView ? "in-view" : "")}
					blocks={quote}
				/>
				{credit && <p className={cx("body", styles.credit)}>— {credit}</p>}
			</Container>
		</div>
	);
};
